import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-575e7368"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "el-button-group" }
const _hoisted_2 = ["onClick"]
const _hoisted_3 = ["onClick"]
const _hoisted_4 = { style: {"padding":"2px","color":"red"} }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"padding":"2px"} }, "(", -1))
const _hoisted_6 = { style: {"padding":"2px"} }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"padding":"2px"} }, "/", -1))
const _hoisted_8 = { style: {"padding":"2px","color":"green"} }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"padding":"2px"} }, ")", -1))

import { computed, ref } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'DataList',
  props: {
    data: {}
  },
  emits: ["showDetails", "showEndDetails", "downloadData"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit

const showDetails = (row: string) => {
  emit('showDetails', row);
};

const showEndDetails = (row: string) => {
  emit('showEndDetails', row);
};

const downloadData = () => {
  emit('downloadData');
}

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_tag = _resolveComponent("el-tag")!
  const _component_el_table = _resolveComponent("el-table")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_el_button, {
        type: "primary",
        icon: "el-icon-download",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (downloadData(_ctx.data)))
      }, {
        default: _withCtx(() => [
          _createTextVNode("导出")
        ]),
        _: 1
      })
    ]),
    _createVNode(_component_el_table, {
      border: "",
      stripe: "",
      fit: "",
      data: _ctx.data,
      style: {"width":"100%"}
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_table_column, {
          prop: "employeeName",
          label: "员工姓名",
          align: "center"
        }),
        _createVNode(_component_el_table_column, {
          prop: "group",
          label: "组别",
          width: "180",
          align: "center"
        }),
        _createVNode(_component_el_table_column, {
          prop: "date",
          label: "日期",
          width: "180",
          align: "center"
        }, {
          default: _withCtx((scope) => [
            _createElementVNode("a", {
              onClick: ($event: any) => (showDetails(scope.row)),
              style: {"cursor":"pointer"}
            }, _toDisplayString(scope.row.date), 9, _hoisted_2)
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          prop: "activePlans",
          sortable: "",
          label: "进行中（总数/成交）",
          width: "180",
          align: "center"
        }, {
          default: _withCtx((scope) => [
            _createElementVNode("div", {
              style: {"width":"100%","height":"100%","cursor":"pointer"},
              onClick: ($event: any) => (showEndDetails(scope.row))
            }, [
              _createElementVNode("span", _hoisted_4, _toDisplayString(scope.row.activePlans), 1),
              _hoisted_5,
              _createElementVNode("span", _hoisted_6, _toDisplayString(scope.row.communicationPlans), 1),
              _hoisted_7,
              _createElementVNode("span", _hoisted_8, _toDisplayString(scope.row.endPlans), 1),
              _hoisted_9
            ], 8, _hoisted_3)
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          prop: "typeA",
          label: "A|B|C|D",
          width: "200",
          align: "center"
        }, {
          default: _withCtx((scope) => [
            _createVNode(_component_el_tag, {
              effect: "dark",
              size: "small",
              hit: false,
              color: "#FFA500",
              style: {"color":"black","margin-right":"2px"}
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(scope.row.typeA), 1)
              ]),
              _: 2
            }, 1024),
            _createVNode(_component_el_tag, {
              effect: "dark",
              size: "small",
              hit: false,
              color: "#FFD76E",
              style: {"color":"black","margin-right":"2px"}
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(scope.row.typeB), 1)
              ]),
              _: 2
            }, 1024),
            _createVNode(_component_el_tag, {
              effect: "dark",
              size: "small",
              hit: false,
              color: "#FFF4B3",
              style: {"color":"black","margin-right":"2px"}
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(scope.row.typeC), 1)
              ]),
              _: 2
            }, 1024),
            _createVNode(_component_el_tag, {
              effect: "dark",
              size: "small",
              hit: false,
              color: "#FFFFE0",
              style: {"color":"black"}
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(scope.row.typeD), 1)
              ]),
              _: 2
            }, 1024)
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          prop: "followUpRecords",
          sortable: "",
          label: "跟踪记录数",
          width: "150",
          align: "center"
        }),
        _createVNode(_component_el_table_column, {
          prop: "followUpPlans",
          sortable: "",
          label: "跟踪计划数",
          width: "150",
          align: "center"
        }),
        _createVNode(_component_el_table_column, {
          prop: "managerSuggestions",
          sortable: "",
          label: "经理建议数",
          width: "150",
          align: "center"
        }),
        _createVNode(_component_el_table_column, {
          prop: "managerSuggestionPlans",
          sortable: "",
          label: "经理建议计划数",
          width: "150",
          align: "center"
        }),
        _createVNode(_component_el_table_column, {
          prop: "aiSuggestions",
          sortable: "",
          label: "AI建议数",
          width: "150",
          align: "center"
        })
      ]),
      _: 1
    }, 8, ["data"])
  ], 64))
}
}

})